import type { CSSProperties, MouseEventHandler, ReactNode } from 'react';

import { twMerge } from 'tailwind-merge';

import { getTestProps } from '../../lib/helpers';

import Topbar from '../../components/Topbar/Topbar';

import { CaretLeftIcon } from '../../images/shapes';

interface PoppingPageLayoutProps {
  /**
   * Page title shown in helmet and topbar
   */
  title: string;
  /**
   * Topbar buttons
   */
  buttons?: ReactNode;
  /**
   * If topbar buttons are disabled
   */
  buttonsDisabled?: boolean;
  /**
   * Page content
   */
  children: ReactNode;
  /**
   * Content object status
   */
  status?: ReactNode;
  /**
   * If page should not have paddings
   */
  noPaddings?: boolean;
  /**
   * Function to call on back button click
   */
  onBack: MouseEventHandler<HTMLButtonElement>;
  /**
   * Component test id
   */
  testId?: string;
}

const PoppingPageLayout = ({
  title,
  buttons,
  buttonsDisabled = false,
  children,
  status,
  noPaddings,
  onBack,
  testId = '',
}: PoppingPageLayoutProps) => {
  return (
    <div
      className="relative h-full w-full pb-10 lg:pb-0"
      style={{ '--flotiqLayoutOffset': '0px' } as CSSProperties}
    >
      <Topbar
        topbarHeading={title || ''}
        buttons={buttons}
        buttonsDisabled={buttonsDisabled}
        status={status}
        beforeHeading={
          <button
            onClick={onBack}
            type="button"
            className="inline-flex py-2 pr-4"
          >
            <CaretLeftIcon className="w-2.5 text-blue" />
          </button>
        }
        {...getTestProps(testId, 'topbar', 'testId')}
      />
      <div className="flex items-stretch w-full min-h-[calc(100vh-71px)]">
        <div className="flex flex-col w-full">
          <div
            className={twMerge('h-full relative', !noPaddings && 'p-4 lg:p-7 ')}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PoppingPageLayout;
